require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./what-is-prog-soc.json") })
        }
      }, "path---what-is-prog-soc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---what-is-prog-soc!./.cache/json/what-is-prog-soc.json
// module id = 388
// module chunks = 231608221292675